import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import palette from '@ui/palette';
import Button from '@ui/Button';
import Icon from '@ui/Icon';
import QuestionMarkIcon from '@ui/Icon/QuestionMark';
import Typography from '@ui/Typography';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  heading: {
    backgroundColor: palette.gray_900,
    padding: theme.spacing(2, 2, 2, 3),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  closeButton: {
    marginLeft: 'auto',
    color: palette.gray_300,
    padding: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

interface DictionaryHeaderProps {
  onClose: () => void;
}

const DictionaryHeader = (props: DictionaryHeaderProps) => {
  const { onClose } = props;
  const { classes } = useStyles();
  return (
    <Box className={classes.heading}>
      <Box className={classes.container}>
        <Typography
          variant="pSm"
          bold
          uppercased
          color="secondary"
        >{`Suggested Respellings`}</Typography>
        <Typography
          variant="pSm"
          color="tertiary"
        >{`Powered by Oxford Languages`}</Typography>
      </Box>
      <QuestionMarkIcon
        text={'Choose a respelling.'}
        href={`https://help.wellsaid.io/hc/en-us/articles/39106324166547-Applying-Respelling-Suggestions`}
        ctaText={'Learn more'}
      />
      <Button
        variant="icon"
        aria-label={'close'}
        className={classes.closeButton}
        onClick={onClose}
      >
        <Icon type="ex" />
      </Button>
    </Box>
  );
};

export default DictionaryHeader;
